<template>
  <avs-button
    v-bind="{ ...$attrs }"
    v-on="{ ...$listeners }"
    color="accent"
    iconI="mdi-plus"
    :menu="menu"
    text
  >
    <template v-slot:name>{{ name }}</template>
    <template
      v-if="menu"
      v-slot:list
    >
      <slot name="list"> LIST </slot>
    </template>
  </avs-button>
</template>

<script>
export default {
  name: "CreateButton",
  props: {
    menu: {
      type: Boolean,
      default: false
    },
    name: {
      type: String
    }
  }
}
</script>
